import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast, Bounce } from 'react-toastify';
import { logo } from '../assets/svg/svg';
import { connectWallet, getCachedWalletAccount } from '../helper/wallet-helper';
import { getUserContract } from '../helper/contract-helper';
import { CompleteLoader } from '../modals/common-alert';

import playimg from '../assets/images/Play.jpg';
import metatumb from '../assets/images/banner-dwallet.jpg';
import dmailtumb from '../assets/images/dmailtumb.png';
import { buildLoginProof } from '../auth/loginProof.js';
import { login } from '../service/api-actions.js';
import Cookies from 'universal-cookie';
import { getContacts } from '../helper/web3helper';
import { deleteDatabase, deleteContacts } from '../db/db-helper';
import { getCacheOwner } from '../db/indexed-helper.js';
import { clearContactsDekCache } from '../helper/contactsDek.js';
import { clearDekCache } from '../helper/dekManager.js';
import { clearEnvelopeKeyCache } from '../helper/envelopeV3.js';
import InstallWalletModal from '../modals/InstallWalletModal';
import { reportError, toErrorString } from '../utils/errorLogger';

const WalletConnect = () => {
  const history = useNavigate(); // Get the history object
  const [loader, setLoader] = useState(false);
  const [text, setText] = useState("");
  const location = useLocation();
  const cookies = new Cookies();
  const storedUser = localStorage.getItem("userObject");
  let userDetails = null;
  const [showInstallModal, setShowInstallModal] = useState(false);

  try {
    if (storedUser) {
      userDetails = JSON.parse(storedUser);
    }
  } catch (error) {
    const errorStr = toErrorString(error || error.message);
    const userName = localStorage.getItem('UserName');
    reportError({
      endpoint: '-',
      message: String(error.message || 'Invalid JSON in storedUser'),
      error: errorStr,
      userName: userName || '',
      level: 'warn',
    });
    console.error("Invalid JSON in storedUser:", storedUser);
  }
  async function connectWalletDetails(userDetails) {
    try {
      setLoader(true)

      const walletAddress = localStorage.getItem("walletAddress");
      if (!walletAddress) {
        //delete cookies and local storage
        cookies.set("userObject", '', { path: "/", maxAge: 0 });
        localStorage.removeItem("userObject");
        localStorage.removeItem("accessToken");
        history('/');
        return;
      }
      await new Promise((resolve) => setTimeout(resolve, 1000));
      if (window.ncogProvider) {
        const accountAddress = await getCachedWalletAccount();
        if (accountAddress?.toLowerCase() !== userDetails?.wallet?.toLowerCase()) return;
      } else {
        toast.error("Please Install NCOG Wallet", {
          toastId: "installerror",
          position: "top-center",
          transition: Bounce,
        });
        return;
      }
      // Build the wallet proof, then perform the login it authorises. The proof failure is caught here
      // rather than left to the outer catch: this reconnect path has no failure branch of its own, so an
      // unapproved wallet prompt is a non-event that must stay a non-event (the outer catch reports to the
      // error backend, which a user simply dismissing the wallet dialog should not trigger).
      let getToken;
      try {
        const { signature, signerPublicKey } = await buildLoginProof(userDetails?.name, userDetails?.publicKey);
        getToken = await login(userDetails?.name, userDetails?.publicKey, null, signature, signerPublicKey);
      } catch (proofError) {
        getToken = { isAuth: false, isAccess: false, message: proofError.message };
      }
      if (getToken && getToken.isAuth && getToken.token) {
        console.log(getToken, "getToken")
        cookies.set("userObject", '', { path: "/", maxAge: 0 });
        const userObject = { name: userDetails?.name, wallet: userDetails.wallet, publicKey: userDetails.publicKey };
        cookies.set("accessToken", getToken?.token, { path: "/" });
        localStorage.setItem("accessToken", getToken?.token);
        cookies.set("userObject", JSON.stringify(userObject), { path: "/" });
        localStorage.setItem("userObject", JSON.stringify(userObject));
        // Same rule as SignIn: keep this account's encrypted cache, wipe only when the cache cannot be
        // proven to belong to the account coming in. This path is a wallet RECONNECT for the user already
        // in storage, so it was wiping the cache — and re-prompting the wallet for every message — on what
        // is normally the very same account.
        //
        // Ordered BEFORE getContacts(), matching SignIn: getContacts primes the contacts DEK, so running
        // it first meant clearContactsDekCache() below threw away a key that had just been unwrapped —
        // costing an extra wallet round-trip on every account switch.
        if (await getCacheOwner() !== userDetails?.name) {
          clearDekCache();
          clearContactsDekCache();
          // And the v3 per-message content keys, which were unwrapped by the previous account's wallet.
          clearEnvelopeKeyCache();
          await deleteDatabase();
          // Also drop the separate 'Dcontact' DB — deleteDatabase() only removes 'web3Dmails', and
          // the contacts rows are keyed by a constant with no owner tag, so they would otherwise
          // leak the previous account's contacts into this session (getContacts runs right below).
          await deleteContacts();
        }
        await getContacts(userDetails?.name);
        history('/inbox');
      }
    }
    catch (error) {
      console.error('error', error);
      const errorStr = toErrorString(error || error.message);
      const userName = localStorage.getItem('UserName');
      reportError({
        endpoint: '/login',
        message: `FileName: WalletConnect.js, Fun: WalletConnect, ${String(error.message || 'Unhandled error')}`,
        error: errorStr,
        userName: userName || '',
      });
    }
    finally {
      setLoader(false);
    }
  }
  useEffect(() => {
    localStorage.removeItem("walletAddress");
    async function getUserDetails() {
      if (userDetails?.name && userDetails?.publicKey && location?.pathname === '/') {
        // await connectWalletDetails(userDetails)
      }
    }
    getUserDetails()
  }, [])

  return (
    <div className='container'>
      <div className='row'>
        <div className='col-lg col-md d-flex justify-content-center text-nowrap'>
          <div className='parent-no-layout-containers common-header-ele metamask w-100'>
            <div className='common-header-ele-text text-center'>
              Connect your NCOG Wallet to Continue
            </div>

            <div className='initial-div-ele-text justify-content-center text-center'>
              Connect your NCOG Wallet here to launch our decentralized mail.
            </div>

            <div className='initial-div-ele-actions cursor-pointer text-center' onClick={async () => {
              try {
                setLoader(true);
                setText("Please wait, data is loading from the blockchain, Going forward it will be fast.")
                if (window.ncogProvider) {

                  const walletAddress = await connectWallet();
                  if (walletAddress) {
                    //set walletAddress local storage
                    localStorage.setItem("walletAddress", walletAddress);
                    const contract = getUserContract();

                    if (walletAddress) {
                      const getUserDetailsForWallet = await contract.methods.getUserDetailsForWallet(walletAddress).call();
                      if (getUserDetailsForWallet.length) {
                        history('signin');
                      } else {
                        history('signup');
                      }
                    }
                  } else {
                    if (!toast.isActive("errorToast")) {
                      toast.error("Please Connect Your NCOG Wallet", {
                        toastId: "errorToast",
                        position: "top-center",
                        transition: Bounce,
                      });
                    }
                  }
                } else {
                  setShowInstallModal(true);
                }
                setLoader(true);
              } catch (error) {
                console.error('error', error);
                const errorStr = toErrorString(error || error.message);
                const userName = localStorage.getItem('UserName');
                reportError({
                  endpoint: '-',
                  message: `FileName: WalletConnect.js, Fun: WalletConnect, ${String(error.message || 'Unhandled error')}`,
                  error: errorStr,
                  userName: userName || '',
                  level: 'warn',
                });
                setLoader(false);
              }
              finally {
                setLoader(false);
                setText("")
              }

            }}>
              {logo.meta_mask}
              <CompleteLoader isOpen={loader} text={text} />
            </div>
            <h4 className="meta-text text-center mt-1">NCOG wallet</h4>
            {/* <button className='faucet-button mt-4' onClick={() => {
              window.open(faucetLink, "_blank");
            }}>
              <span>Get Free Test Tokens?<br />(NEC Faucet)</span>
            </button> */}
          </div>
        </div>

        {/* <div className='col-lg-5 col-md-12' style={{ marginTop: '50px' }}>
          <div className='tutorial-text mt-3 text-start'>Tutorial <span className='mt-1'>{logo.info_icon_svg}</span></div>
          <div className='row justify-content-center'>
            <div className='video-section col-12 w-100 mt-4'>
              <div className='video-content w-100' style={{
                backgroundImage: !isMetaTutorial ? `url('${metatumb}')` : '',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
              }}>
                {!isMetaTutorial &&
                  <span onClick={() => { setMetaTutorial(true) }} className='cursor-pointer d-block text-center'>
                    <img src={playimg} style={{ borderRadius: '50%' }} alt="Play" className="mx-auto" />
                  </span>
                }
                {isMetaTutorial &&
                  <iframe className='w-100' src="https://www.youtube.com/embed/A7sbpFvkEe0?autoplay=1" allowFullScreen
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    title="Metamask Tutorial"></iframe>
                }
              </div>
              <p className='video-content-text text-center'>How to create an NCOG Wallet</p>
            </div>

            <div className='video-section mt-3'>
              <div className='video-content w-100' style={{
                backgroundImage: !isTutorial ? `url('${dmailtumb}')` : '',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
              }}>
                {isTutorial &&
                  <iframe className='w-100' src={`https://www.youtube.com/embed/qaqgmw3HQDA?autoplay=1`} allowFullScreen
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    title="Dmail Tutorial"></iframe>
                }
                {!isTutorial &&
                  <span onClick={() => { setTutorial(true) }} className='cursor-pointer d-block mx-auto text-center'>
                    <img src={playimg} style={{ borderRadius: '50%' }} alt="Play" className="mx-auto" />
                  </span>
                }
              </div>
              <p className='video-content-text text-center'>How to create and use Dmail</p>
            </div>
          </div>
        </div> */}
      </div>
      <InstallWalletModal isOpen={showInstallModal} onClose={() => setShowInstallModal(false)} />
    </div >
  )
}

export default WalletConnect;
